@if (loadedAttachments()) {
	<div class="sections">
		<div class="created-by">
			<p class="select-label">{{ 'created' | translate }}</p>
			<au-avatar-with-name [data]="fileEntity?.createdBy" />
			<span class="body-2 grey">{{ fileEntity.created | dateAgo }}</span>
		</div>

		<cmms-locations-section
			(locationsChanged)="locationsChanged($event)"
			[locationsInputList]="fileEntity.locations"
		/>

		<document-type
			[documentType]="fileEntity.type"
			(typeChanged)="documentTypeChanged($event)"
		/>

		<div class="metadata-table-wrapper m-b-sm">
			<file-metadata-table
				(downloadPressed)="downloadFile()"
				(replacePressed)="replaceFileButtonClick(fileInput)"
				[class.blured]="replacingInProgress | async"
				[fileData]="fileEntity"
			/>

			@if (replacingInProgress | async) {
				<div class="spinner-wrapper">
					<mat-spinner diameter="40" />
				</div>
			}
		</div>

		<div class="m-b-m">
			<cmms-labels-section
				[labelsList]="fileEntity.labels"
				(labelsListChanged)="labelsChanged($event)"
			/>
		</div>

		<div class="notes m-b-m">
			<cmms-description
				(controlReady)="addChildControl('notes', $event)"
				(descriptionBlur)="editFileEntityNotes($event)"
				[description]="fileEntity.notes"
				headerText="notes"
				[textModeEnabled]="true"
			/>
		</div>

		<div class="sections">
			<cmms-classification
				(classificationsListChanged)="classificationsListChanged($event)"
				[attachedClassification]="classifications"
				[allowedStandards]="['BCT', 'CCB']"
				class="m-b-xs"
			/>

			<assets-section
				(newAsset)="navigateTo($event)"
				(openAssets)="openAssets()"
				(rowSelect)="viewSelected($event.data)"
				(unlink)="unlinkAsset($event.data)"
				[assets]="attachedAssets"
			/>

			<entity-section
				(addExistingEntityItem)="navigateToExist($event)"
				(addNewEntityItem)="navigateTo($event)"
				(unlink)="unlinkWorkOrder($event.data)"
				[entityType]="cmmsPages.editWorkOrder"
				[tableColumns]="tableConfig"
				[tableData]="attachedWO"
				(rowSelect)="viewSelected($event)"
			/>

			<entity-section
				(addExistingEntityItem)="navigateToExist($event)"
				(addNewEntityItem)="navigateTo($event)"
				(unlink)="unlinkIncident($event.data)"
				[entityType]="cmmsPages.editIncident"
				[tableColumns]="tableConfig"
				[tableData]="attachedIncidents"
				(rowSelect)="viewSelected($event)"
			/>

			<entity-section
				(addExistingEntityItem)="navigateToExist($event)"
				(addNewEntityItem)="navigateTo($event)"
				(unlink)="unlinkRequest($event.data)"
				[entityType]="cmmsPages.editRequest"
				[tableColumns]="tableConfig"
				[tableData]="attachedRequest"
				(rowSelect)="viewSelected($event)"
			/>
		</div>
	</div>

	<div class="comments m-t-m" id="Other">
		<au-comments
			(deleteComment)="deleteCommentConfirmation($event)"
			[commentsList]="fileEntity.comments"
			(editComment)="editComment($event)"
		/>
	</div>

	<div class="type-comment">
		<comment-input (commentSubmitted)="submitComment($event)" />
	</div>

	<input
		#fileInput
		(change)="replaceFile($event)"
		[multiple]="false"
		hidden
		type="file"
	/>
} @else {
	<div class="spinner-wrapper">
		<mat-spinner diameter="60" />
	</div>
}
